module.exports = __webpack_public_path__ + "static/media/textStop.c5b6f9aa.png";